import PropTypes from 'prop-types';
import { FC, ReactNode, useEffect } from 'react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'src/store';
import { SocketDataInterface } from 'src/types/socket';
import useAuth from '../hooks/useAuth';
interface GuestGuardProps {
  children?: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isConnected }: SocketDataInterface = useSelector((state) => state.socket);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  
  useEffect(()=>{
    if (isAuthenticated && !isConnected) {
      navigate('/select-tunnel');
    } else if (isAuthenticated && isConnected) {
      navigate('/app/tunnel');
    }
  }, [isAuthenticated, isConnected])
  
  return (
    <>
      {children}
    </>
  );
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
